export const BUILDING_STATUS = {
  OWN: "Milik Sendiri",
  RENT: "Sewa",
  BOARDING: "Kost",
  PUBLIC_FACILITIES: "Fasilitas Umum"
}